<div class="text-chathams-blue">
  <div class="flex justify-center items-center" style="height: 80vh">
    <div class="flex flex-col justify-center items-center gap-12">
      <span class="text-8xl font-bold"> 403 </span>
      <div class="text-center pt-12 font-bold text-xl">
        <h1>Usuário não possui as permissões necessárias para o acesso.</h1>
      </div>
      <div
        class="flex justify-center items-center gap-4"
        *ngIf="sessionService.getToken() as authenticated"
      >
        <ng-container *ngIf="authenticated">
          <button
            class="btn bg-chathams-blue text-xl text-white w-28 flex justify-center items-center"
            (click)="back()"
          >
            Voltar
          </button>
        </ng-container>

        <a
          class="btn bg-chathams-blue text-xl text-white w-28 flex justify-center items-center"
          routerLink="/"
          *ngIf="!authenticated"
        >
          Login
        </a>
      </div>
    </div>
  </div>
</div>
